import { useNavigate, useLocation } from "react-router-dom";
import { controlDocInfoForPreUpload } from "../../api/api";

function MainComponent({ handleLoading }) {

    document.title = "預り証確認| ファーストコンタクトセンター";
    const navigate = useNavigate();
    const location = useLocation();
    const userName = location.state.userName;
    const companyName = location.state.companyName;
    const divisionName = location.state.divisionName;
    const secretInfo = location.state.secretInfo;
    const personalInfo = location.state.personalInfo;
    const caseId = location.state.caseId;
    const contactId = location.state.contactId;
    const next_state = {
        userName: userName,
        companyName: companyName,
        divisionName: divisionName,
        secretInfo: secretInfo,
        personalInfo: personalInfo,
        caseId: caseId,
        contactId: contactId,
        page: true
    };

    const goNext = async () => {
        handleLoading(true);
        let ret = await controlDocInfoForPreUpload(
            caseId,
            contactId,
            userName,
            companyName,
            divisionName,
            secretInfo,
            personalInfo);
        if (ret) {
            navigate("/file_upload", { state: next_state });
        } else {
            alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
        }
        handleLoading(false);
    }

    const goBack = () => {
        navigate("/file_info_edit", { state: { next_state: next_state } })
    }
    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>預り証確認</span>
                    </h2>

                    <div className="mod-txt">
                        <p>
                            預り証は以下の内容です。
                        </p>
                    </div>

                    <h4 className="mod-hdg-l4-02">
                        預り証情報
                    </h4>

                    <div className="mod-list">
                        <ul className="list">
                            <li>
                                <div className="mod-txt">
                                    <p id="notificate"></p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="mod-tbl">
                        <table>
                            <colgroup>
                                <col className="w-20" />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: "left" }}>預り証</th>
                                </tr>
                            </thead>
                            <tbody className="inquiry_list">
                                <tr>
                                    <td>
                                        <div>
                                            <p style={{ textAlign: "center" }}>お預り証</p>
                                            <p id="inquiry_no"></p>
                                            <p>
                                            </p>
                                            <p id="user"></p>
                                            <p id="from" style={{ textAlign: "right" }}></p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
                                            <p>
                                                NEC ファーストコンタクトセンターは、管理者の注意義務をもって、当該データを以下に記載する目的のためにのみ使用するものとし、データ送付中の事故に関しては、一切関与いたしません。
                                            </p>
                                            <p>
                                                また、お預りしたデータは、返却いたしません。
                                            </p>
                                            <p>
                                                尚、当該データについては、お客様の他のお問い合わせの調査に利用させていただく場合もございます。<br />
                                                当該目的のために必要な作業の終了後は、当該データを消去いたします。<br />
                                                ただし、他のお問い合わせで利用させていただいている場合は、他のお問い合わせの対応終了後に消去いたします。
                                            </p>
                                        </div>
                                        <table>
                                            <tbody style={{ border: "none", marginLeft: "auto", marginRight: "auto" }}>
                                                <tr style={{ border: "none" }}>
                                                    <td style={{ border: "none" }}>□目的</td>
                                                    <td style={{ border: "none" }}>：調査のため</td>
                                                </tr>
                                                <tr style={{ border: "none" }}>
                                                    <td style={{ border: "none" }}>□秘密情報</td>
                                                    <td id="secret_info" style={{ border: "none" }}>：{secretInfo ? "■有　□無" : "□有　■無"}</td>
                                                </tr>
                                                <tr style={{ border: "none" }}>
                                                    <td style={{ border: "none" }}>□個人情報</td>
                                                    <td id="personal_info" style={{ border: "none" }}>：{personalInfo ? "■有　□無" : "□有　■無"}</td>
                                                </tr>
                                                <tr style={{ border: "none" }}>
                                                    <td style={{ border: "none" }}>□お預り方法</td>
                                                    <td style={{ border: "none" }}>：電子データ</td>
                                                </tr>
                                                <tr style={{ border: "none" }}>
                                                    <td style={{ border: "none" }}>□消去方法</td>
                                                    <td style={{ border: "none" }}>：消去</td>
                                                </tr>
                                                <tr style={{ border: "none" }}>
                                                    <td style={{ border: "none" }}>□消去予定日</td>
                                                    <td style={{ border: "none" }}>：お客様お問い合わせ対応終了日から30日後</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button onClick={goBack} className="of-left">修正</button>
                        </div>
                        <div className="btn">
                            <button id="btn-send" className="btn_default_select"
                                onClick={goNext}>OK</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    )
}
export default MainComponent;